export default __webpack_public_path__ + "static/media/r_quote.c6a53688.svg";